import React, { FC, useEffect, useRef } from 'react';
import { Setting } from '../App';
import classes from '../asset/css/main.module.css';
import { Complete } from '../components/Complete';

export const SubscriptionCancelComplete: FC<{ setting: Setting }> = ({ setting }) => {
  const root = useRef<HTMLDivElement>(null);
  useEffect(() => {
    setting.resize(root.current?.clientHeight ?? 0);
  }, [setting, root.current?.clientHeight]);

  return (
    <>
      <div className={classes.mypage_subsc_container} ref={root}>
        <Complete
          title="BOXプランの解約が完了しました"
          body={`
            解約を確かに承りました。<br />
            解約完了メールをご登録のアドレスに<br />
            送付いたしましたので、ご確認ください。<br />
            <br />
            これからもあなたの美肌人生が続いていくことを、<br />
            XOUL JAPAN一同、心よりお祈りしています。<br />
            <br />
            <strong>◆LINE連携をされている方へ◆</strong><br />
            システムの都合上、3～4週間以内に<br />
            リマインドのご連絡が届いてしまうことがございます。<br />
            こちらのページにて「解約は確定」しておりますので、<br />
            ご安心ください。
          `}
          backTo={`${document.referrer.replace(/\/$/, '')}/account`}
          isParent={true}
        />
      </div>
    </>
  );
};
